import { StyledImage } from '../../Atoms'
import { styled } from '../../Styles/stitches.config'

export const StyledChoiceDialog = styled('div', {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',

    [`& ${StyledImage}`]: {
        maxH: 20,
    },
})
